export const EMAIL_REGISTER_FORM_TEST_ID = "email-register-form";
export const OTHER_REGISTER_OPTIONS_TEST_ID = "other-register-options";
